import { useState } from 'react';

import Editor, { LoadingFallback, pluginPresets } from 'my-editor';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

const rootCss = ({ spacing }) => ({
  '.SC-btns': {
    marginTop: spacing(2),
    '& > * + *': { marginLeft: spacing(1) },
  },
  '.SC-solutionListItem': {
    marginBottom: spacing(4),
  },
});

export default function SolutionContent({ className, printMode, solution }) {
  const [lastPartIdx, setLastPartIdx] = useState(1);

  if (!solution) return null;
  if (Array.isArray(solution)) {
    return (
      <div className={className} css={rootCss}>
        {solution.slice(0, printMode ? undefined : lastPartIdx).map((solPart, idx) => (
          <Grid key={idx} className="SC-solutionListItem" container>
            <Grid size={1}>
              <Typography color="primary">{`${idx + 1}/${solution.length}`}</Typography>
            </Grid>
            <Grid size={11}>
              <Editor
                key={idx}
                fallback={<LoadingFallback value={solPart} />}
                plugins={pluginPresets.ALL}
                readOnly
                value={solPart}
              />
            </Grid>
          </Grid>
        ))}
        {!printMode && lastPartIdx < solution.length && (
          <div className="SC-btns">
            <Button onClick={() => setLastPartIdx(lastPartIdx + 1)} size="small" variant="contained">
              Next Step
            </Button>
            <Button onClick={() => setLastPartIdx(solution.length)} size="small" variant="outlined">
              Show All
            </Button>
          </div>
        )}
      </div>
    );
  }
  return (
    <Editor
      className={className}
      fallback={<LoadingFallback value={solution} />}
      plugins={pluginPresets.ALL}
      readOnly
      value={solution}
    />
  );
}
